import React from 'react';
import { 
    Card, 
    CardHeader, 
    CardContent, 
    Typography,
    Box,
    Icon
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import OwnerSelection from './OwnerSelection';

const OwnerSelectionCard = ({
    value,
    onChange,
    label = "Resource Owner",
    title = "Resource Owner",
    showInAdvancedMode = false,
    advanced = true,
    marginBottom = '20px',
    style = {},
    disabled = false,
    filteredUsers = null,
    adminOnly = false
}) => {
    const currentUser = useSelector(({ auth }) => auth.user);
    
    // Only show for super-admin users
    const isSuperAdmin = currentUser.role && currentUser.role.includes('super-admin');
    
    // Check if should show based on advanced mode setting
    const shouldShow = isSuperAdmin && (!showInAdvancedMode || advanced);
    
    if (!shouldShow) {
        return null;
    }

    // Define styles for the card
    const cardStyle = {
        marginBottom: marginBottom,
        boxShadow: '0 2px 10px 0 rgba(0,0,0,0.1)',
        borderRadius: '8px',
        overflow: 'visible',
        ...style
    };

    const cardHeaderStyle = {
        paddingBottom: '8px',
        backgroundColor: '#f7f9fc'
    };

    const sectionTitleStyle = {
        fontSize: '16px',
        fontWeight: 600,
        color: '#0f2147'
    };

    return (
        <div style={{marginBottom: marginBottom, width: style.width || 'auto'}}>
            <Card style={cardStyle}>
                <CardHeader
                    title={
                        <Box display="flex" alignItems="center">
                            <Icon style={{marginRight: '8px', color: '#2196F3'}}>person</Icon>
                            <Typography style={sectionTitleStyle}>{title}</Typography>
                        </Box>
                    }
                    style={cardHeaderStyle}
                />
                <CardContent>
                    <OwnerSelection
                        value={value}
                        onChange={onChange}
                        label={label}
                        disabled={disabled}
                        filteredUsers={filteredUsers}
                        adminOnly={adminOnly}
                    />
                </CardContent>
            </Card>
        </div>
    );
};

export default OwnerSelectionCard;
